/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ProjectTab from 'components/Projects/ProjectTab';

const ProjectDashboard = props => {
  return <ProjectTab {...props} />;
};

export default ProjectDashboard;
